<script lang="ts" setup>
import { computed, ref } from "vue";
import { useAuthStore } from "@/store/auth/auth.store";
import HomeNavigationButton from "@/modules/public/components/HomeNavigationButton.vue";
import HomeNavigationOverTaalblobs from "@/modules/public/components/HomeNavigationOverTaalblobs.vue";
import HomeNavigationOndersteuning from "@/modules/public/components/HomeNavigationOndersteuning.vue";
import { useDisplay } from "vuetify";

const { lgAndUp } = useDisplay();

const menuActive = ref(false);
const authStore = useAuthStore();

function toggleMenu(): void {
  menuActive.value = !menuActive.value;
}

const showMenu = computed(() => {
  return !lgAndUp.value && menuActive.value;
});
</script>

<template>
  <v-app-bar id="main-nav" flat style="overflow: visible" class="border-b">
    <div class="d-flex align-center w-100 px-4 px-md-8">
      <RouterLink :to="{ name: 'home' }">
        <img
          class="d-block"
          style="height: 2rem; width: auto"
          src="/assets/logo_taalblobs.png"
          alt=""
          width="200"
          height="35"
        />
      </RouterLink>
      <div
        style="flex-grow: 1"
        :class="{ 'd-block': showMenu }"
        @click="menuActive = false"
        :style="
          showMenu
            ? `position: absolute;
                top: 56px;
                left: 0;
                right: 0;
                z-index: 99;
                height: calc(100vh - 56px)`
            : ``
        "
      >
        <div style="background-color: white">
          <ul
            class="align-center"
            :class="{ 'd-flex': !showMenu, 'd-block': showMenu }"
            style="list-style: none"
            :style="
              showMenu
                ? `
          padding: 1rem 1.5rem;
          box-shadow: 0 2rem 2rem rgba(0, 0, 0, 0.2);`
                : ``
            "
          >
            <li style="flex-grow: 1"></li>

            <HomeNavigationButton
              :class="{ 'd-none d-md-inline': !showMenu }"
              name="home"
              to="home"
            />
            <HomeNavigationOverTaalblobs
              :class="{ 'd-none d-lg-inline': !showMenu }"
            />
            <HomeNavigationButton
              :class="{ 'd-none d-md-inline': !showMenu }"
              name="prijzen"
              to="prijzen"
            />
            <HomeNavigationOndersteuning
              :class="{ 'd-none d-md-inline': !showMenu }"
            />
            <HomeNavigationButton
              :class="{ 'd-none d-lg-inline': !showMenu }"
              name="training"
              to="trainingen"
            />

            <li style="flex-grow: 1"></li>
            <template v-if="authStore.user">
              <li
                :class="{ 'd-none d-md-inline': !showMenu }"
                v-if="
                  authStore.user.role === 'superadmin' ||
                  authStore.user.role === 'office'
                "
              >
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  class="mr-4 mr-md-0 mt-4 mt-md-0"
                  variant="outlined"
                  color="primary"
                  :to="{ name: 'o-dashboard' }"
                >
                  Dashboard
                </v-btn>
              </li>
              <li
                :class="{ 'd-none d-md-inline': !showMenu }"
                v-if="
                  authStore.user.role === 'schooladmin' ||
                  authStore.user.role === 'docent'
                "
              >
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  class="mr-4 mr-md-0 mt-4 mt-md-0"
                  variant="outlined"
                  color="primary"
                  :to="{
                    name: 'a-groepen',
                    params: {
                      adminId: authStore.user.adminId,
                    },
                  }"
                >
                  Beheeromgeving
                </v-btn>
              </li>

              <li :class="{ 'd-none d-md-inline': !showMenu }" v-if="authStore.user.role === 'leerling'">
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  class="mr-4 mr-md-0 mt-4 mt-md-0"
                  variant="outlined"
                  color="primary"
                  :to="{
                    name: 'l-landkaart',
                    params: { leerlingId: authStore.user._id },
                  }"
                >
                  Leerlingomgeving
                </v-btn>
              </li>

              <li :class="{ 'd-none d-md-inline': !showMenu }" class="pl-2">
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  class="mr-4 mr-md-0 mt-4 mt-md-0"
                  variant="flat"
                  color="primary"
                  @click="authStore.logout()"
                >
                  Uitloggen
                </v-btn>
              </li>
            </template>
            <template v-else>
              <li class="pr-2">
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  :class="{
                    'mr-4 mt-4': showMenu,
                  }"
                  variant="tonal"
                  color="primary"
                  :to="{ name: 'aanvraagformulier' }"
                >
                  Demo aanvragen
                </v-btn>
              </li>

              <li>
                <v-btn
                  :block="$vuetify.display.mdAndDown"
                  :class="{
                    'mr-4 mt-4': showMenu,
                  }"
                  variant="flat"
                  color="primary"
                  :to="{ name: 'login' }"
                >
                  Login
                </v-btn>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <div class="d-flex align-center ml-auto">
        <ul class="d-flex align-center d-md-none" style="list-style: none">
          <template v-if="authStore.user">
            <li
              class="mr-2"
              v-if="
                authStore.user.role === 'superadmin' ||
                authStore.user.role === 'office'
              "
            >
              <v-btn
                variant="flat"
                size="small"
                color="primary"
                :to="{ name: 'o-dashboard' }"
              >
                Dashboard
              </v-btn>
            </li>
            <li
              class="mr-2"
              v-if="
                authStore.user.role === 'schooladmin' ||
                authStore.user.role === 'docent'
              "
            >
              <v-btn
                variant="flat"
                size="small"
                color="primary"
                :to="{
                  name: 'a-groepen',
                  params: {
                    adminId: authStore.user.adminId,
                  },
                }"
              >
                Beheeromgeving
              </v-btn>
            </li>

            <li class="mr-2" v-if="authStore.user.role === 'leerling'">
              <v-btn
                variant="flat"
                size="small"
                color="primary"
                :to="{
                  name: 'l-landkaart',
                  params: { leerlingId: authStore.user._id },
                }"
              >
                Leerlingomgeving
              </v-btn>
            </li>
          </template>
          <!--          <template v-else>-->
          <!--            <li class="pr-2">-->
          <!--              <v-btn-->
          <!--                :block="$vuetify.display.mdAndDown"-->
          <!--                variant="tonal"-->
          <!--                color="primary"-->
          <!--                :to="{ name: 'aanvraagformulier' }"-->
          <!--              >-->
          <!--                Registreren-->
          <!--              </v-btn>-->
          <!--            </li>-->

          <!--            <li>-->
          <!--              <v-btn-->
          <!--                :block="$vuetify.display.mdAndDown"-->
          <!--                variant="flat"-->
          <!--                color="primary"-->
          <!--                :to="{ name: 'login' }"-->
          <!--              >-->
          <!--                Login-->
          <!--              </v-btn>-->
          <!--            </li>-->
          <!--          </template>-->
        </ul>

        <VAppBarNavIcon class="d-block d-lg-none" @click="toggleMenu()" />
      </div>
    </div>
  </v-app-bar>
</template>

<style lang="scss">
#main-nav .v-toolbar__content {
  overflow: visible;
}
</style>
